import React, { useRef } from "react"
// reactstrap components
import {
    Card,
    CardHeader,
    CardBody,
    Container,
    Row,
    Col,
    Button
} from "reactstrap";
// core components
import Header from "../../../components/headers/Header";
import LoadingIndicator from "../../../components/ui/LoadingIndicator";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { useForm } from "react-hook-form";

import { Actions, reducer, INITIAL_STATE, ActionTypes } from "../../../redux/screens/admin/talkchinese/EditRedux";
import AuthorizedScreen from "../../../components/base/AuthorizedScreen";
import { NavigationService, NavigateActionTypes } from "../../../navigation";
import UIDs from "../../../UIDs";

const uid = UIDs.screens.admin.talkchinese.edit;

class EditScreen extends AuthorizedScreen {
    get routeName() {
        return uid;
    }

    get reducer() {
        return reducer;
    }

    get actionHandlers() {
        return {
            [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: { done: null, error: this._handleAsyncActionError },
            [ActionTypes.SAVE_ASYNC]: { done: this._handleSaveAsyncDone, error: this._handleAsyncActionError }
        };
    }

    localVars = {
        navParams: {}
    };

    constructor(props) {
        super(props);

        this.localVars.navParams = NavigationService.getNavParams(props);
    }

    componentDidMount() {
        super.componentDidMount();

        const { id } = this.localVars.navParams;
        if (id) {
            this.props.loadScreenViewAsync(id);
        }
    }

    render() {
        const { book } = this.props.localState;

        return (
            <>
                <Header />
                <Container className="mt--7" fluid>
                    <Row>
                        <div className="col">
                            {this.isActionExecuting(ActionTypes.LOAD_SCREEN_VIEW_ASYNC)
                                ? <LoadingIndicator />
                                : <EditForm
                                    {...this.props}
                                    book={book}
                                    onCancel={this._handleCancelEdit}
                                    onSave={this._handleSave}
                                    isDisabled={this.isActionExecuting(ActionTypes.SAVE_ASYNC)}
                                />
                            }
                        </div>
                    </Row>
                </Container>
            </>
        );
    }

    _handleCancelEdit = () => {
        NavigationService.navigateByAction(this, NavigateActionTypes.BACK);
    }

    _handleSave = (data) => {
        confirmAlert({
            title: this.props.t("confirmToSave"),
            message: this.props.t("sureToDo"),
            buttons: [
                {
                    label: this.props.t("yes"),
                    onClick: () => {
                        this.props.saveAsync({ ...data, partnerId: this.props.partnerId, type: 3 });
                    }
                },
                {
                    label: this.props.t("no")
                }
            ]
        });
    }

    _handleSaveAsyncDone = (action) => {
        const { id } = action.data;
        NavigationService.navigateToPage(this, `/admin/talkchinese/${id}/details`);
    }

    _handleAsyncActionError = (action) => {
        this.displayError(action.error);
    }
}

function EditForm(props) {
    const { book } = props;
    const { id, title } = book;
    const { register, handleSubmit, errors } = useForm();
    const submitRef = useRef();

    return (
        <Card className="shadow">
            <CardHeader className="bg-white border-0">
                <Row className="align-items-center">
                    <Col xs="8">
                        <h3 className="mb-0">{props.t(id ? "edit" : "create")}</h3>
                    </Col>
                    <Col className="text-right" xs="4">
                        <Button
                            color="info"
                            onClick={() => submitRef.current.click()}
                            disabled={props.isDisabled}
                            size="sm">
                            {props.t("save")}
                        </Button>&nbsp;
                        <Button
                            color="default"
                            onClick={props.onCancel}
                            disabled={props.isDisabled}
                            size="sm">
                            {props.t("cancel")}
                        </Button>
                    </Col>
                </Row>
            </CardHeader>
            <CardBody>
                <form onSubmit={handleSubmit(props.onSave)}>
                    <input name="id" hidden type="text" className="form-control" defaultValue={id} ref={register} />
                    <input name="visibility" hidden type="text" className="form-control" value={1} ref={register} />
                    <div className="pl-lg-4">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="form-group">
                                    <label className="form-control-label">{props.t("title")}</label>
                                    <input name="title" type="text" className="form-control-alternative form-control" defaultValue={title} maxLength={100}
                                        ref={register({ required: true })} />
                                    {errors.title && <span className="text-danger">{props.t("fieldIsRequired")}</span>}
                                </div>
                            </div>
                        </div>
                    </div>
                    <input ref={submitRef} type="submit" hidden />
                </form>
            </CardBody>
        </Card>
    );
}

const mapStateToProps = state => {
    return {
        localState: state.screens[reducer.key] ? state.screens[reducer.key] : INITIAL_STATE,
        userId: state.session.userId,
        partnerId: state.session.partner ? state.session.partner.id : null
    };
};

const mapDispatchToProps = dispatch => {
    return {
        loadScreenViewAsync: id => dispatch(Actions.loadScreenViewAsync(id)),
        saveAsync: vo => dispatch(Actions.saveAsync(vo))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(uid)(EditScreen));